export default __webpack_public_path__ + "static/media/emotionalLife.832e4718.jpeg";